// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2ou7d","logo":"styles_logo__rv5r5","unavailable":"styles_unavailable__22eA0"};